import ajax from '../utils/request'
const hotApi = {
/***************************热点管理****************************** */
/*************************排行页面***************************** */
  // 排行列表
  getRankList(params) {
    return ajax({
      ulr: '',
      type: 'get',
      params: params
    })
  },
  // 编辑排行
  updateRank(params) {
    return ajax({
      url: '',
      type: 'post',
      params: params
    })
  },
/*************************发现精彩***************************** */
  // 发现精彩列表
  getWonderfulList(params) {
    return ajax({
      url: '',
      type: 'get',
      params: params
    })
  },
// 编辑精彩
  updateWonderful(params) {
    return ajax({
      url: '',
      type: 'post',
      params: params
    })
  },
}

export default hotApi